import React from "react"

const akansha_patil = () => {
    return (
        <div>
<h1>Akansha Patil</h1>

<h4><em>Computer Engineering, Batch of 27'<br/><hr/></em></h4>

<p><strong>CSI  Internship Diaries 2025</strong></p>

<p><strong>What was the criteria for shortlisting candidates in the initial stages of the recruitment process</strong>?<br />
There was an online aptitude test and students eligible for online aptitude were required to fulfill the below criteria-<br />
CGPA: 7+ and no backlogs</p>

<p><strong>What was the Timeline of the entire Interview Process</strong>?<br />
Aptitude Test Date : Oct 18th<br />
Shortlisting Date : October 30th<br />
Interview Date : November 4th (1 technical round and 1 HR round)<br />
Final result(for SMBF):Same day by 6pm</p>

<p><strong>What was the Structure of the Aptitude Round?</strong><br />
3 DSA questions based on graphs , strings and trees.(different for all)</p>

<p><strong>How many students were shortlisted after the Aptitude Round?</strong><br />
35 students for SMBF role.<br />
21 students for PBWMT role.</p>

<p><strong>After being shortlisted, how long was the wait time before the interviews began? During this period, what specific areas did you focus on to prepare effectively?</strong><br />
We had 4 days to prepare for the interviews.I focused my preparation on all the areas listed below:<br />
<strong>OOPs</strong>: Revised concepts through GeeksforGeeks and my own notes.<br />
<strong>OS:</strong> Reviewed fundamental concepts like processes, threads, memory management, and scheduling.<br />
<strong>DSA:</strong> Solved a few problems and refreshed important concepts by going through my notes.<br />
<strong>DBMS</strong>: Practiced SQL queries and reviewed my notes.<br />
<strong>Projects:</strong> Went over all projects on my resume and prepared for common questions.<br />
<strong>HR Round:</strong> Practiced answers to behavioral questions and reflected on my strengths and experiences.  </p>

<p><strong>How many Interview Rounds were there for the company, can you elaborate about each round in brief? Also mention, how many students were shortlisted after each Interview Round?</strong><br />
The company conducted 2 rounds:<br />
Technical round:<br />
The interview kicked off with questions about my resume, starting with my Invoice Management System project. They wanted to know how the system worked, specifically how I handled the database and the authentication process. I was also asked to explain key concepts related to Node.js, React that were part of the project.They asked me questions based on how I would also implement certain features in my project and what difference they would make.I was also asked basic OOPs questions and certain OS concepts.They also inquired about the Summer internship that I did in 2025.</p>

<p>HR round:<br />
The HR round was very open and engaging which helped me feel at ease. They started by asking about my schooling background, where I shared details about my academic journey and also the subjects I found most interesting.After that the conversation naturally transitioned to questions about my motivation for applying to the company.The interview ended with the HR asking if I had any questions for him which gave me a chance to inquire about the different opportunities and the team dynamics which showed my genuine interest in the role.</p>

<p><strong>What Topics or Skills did the interviewers focus on during the interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or Behavioral questions)</strong><br />
Most questions asked to me were resume based which included project based questions and also all the basic OS and OOPs concepts they asked. One situational question was also asked to understand my problem-solving approach and how I would handle real-world scenarios.</p>

<p><strong>What are some good resources that you used in your Internship Prep?</strong><br />
Strivers A2Z Sheet, Hackerrank and Leetcode :For Coding Questions and various patterns which are used in solving questions<br />
OS: Codehelp by Babbar’s placement series<br />
DBMS: CodeHelp by Babbar’s placement series<br />
OOPS: Geeks for geeks<br />
Puzzles: Geeks for geeks</p>

<p><strong>Some tips to crack Coding Questions?</strong><br />
Be confident and calm. Make sure to think out loud and explain your thought process, as this helps the interviewer evaluate the approach you're taking. Don’t hesitate to ask any clarifying questions if you have doubts about the problem.<br />
Take your time to answer and break down the problem into smaller subproblems for easier problem-solving. Most importantly don’t stress stay calm and focused.</p>

<p><strong>How many questions were asked about Projects, Clubs, and Extracurricular activities in your resume</strong>?<br />
A significant number of questions were asked from my projects and also my summer internship of 2025. No questions asked on my extracurricular activities.</p>

<p><strong>Is there something specific that you would want to tell people who are preparing for the same company</strong>?<br />
I would suggest focusing on having well-prepared, detailed projects to discuss, with a strong understanding of the tech stack you’ve worked with. Make sure you can explain the architecture, challenges, and your contributions to the projects. Also be confident with your knowledge of the technologies listed on your resume as deep familiarity with them will really help you stand out.</p>

<p><strong>Any Final Tips for Juniors?</strong><br />
The interview process might feel tough and exhausting, especially when balancing academics, but one thing you need to remember is to never give up and keep working on yourself. Do not focus on what others are doing, and don’t compare yourself to them. Never doubt your potential and just keep working hard.</p>

<p><strong>Contact Info</strong><br />
<strong>Phone No :</strong> 8080527347<br />
<strong>Email :</strong> <a href="mailto:akanshakp23.comp@coeptech.ac">akanshakp23.comp@coeptech.ac</a><br />
<strong>LinkedIn :</strong><a href="https://linkedin.com/in/akansha-patil-764682204"> Akansha Patil</a></p>

        </div>
    )
}

export default akansha_patil
